import AppContext from "context/Context";
import { getColor, getItemFromStore } from "helpers/utils";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { settings } from "./config";
import useToggleStyle from "./hooks/useToggleStyle";
import { configReducer } from "./reducers/configReducer";

import { LoginAPI } from "api/LoginAPI";
import { Chart as ChartJS, registerables } from "chart.js";
import { AgencyDetailAPI, MenusAPI, UserProfileInfoAPI } from "api";

ChartJS.register(...registerables);

const initialState = {
  isLoading: false,
  user: JSON.parse(localStorage.getItem("user")) ?? null,
  token: localStorage.getItem("token"),
  userProfile: null,
};

// console.log(initialState.user);

const Main = (props) => {
  const [state, setState] = useState(initialState);

  // Check if user has admin role
  const isAdmin = () => {
    const user = state.user;
    if (!user) return false;

    // Check for admin role in different possible locations
    const userRole = user?.role || user?.roleId?.name || user?.userRole?.name;
    return userRole?.toLowerCase() === "admin";
  };

  // Check if user has access to admin panel
  const hasAdminAccess = () => {
    return isAdmin();
  };

  const hasRole = (role) => {
    const userRole =
      state.user?.role ||
      state.user?.roleId?.name ||
      state.user?.userRole?.name;
    return userRole?.toLowerCase() === role?.toLowerCase();
  };

  const login = async (email, password) => {
    const data = { email, password };

    const response = await LoginAPI.post(data);
    console.log("response", response);
    const userInfo = response.data?.data?.user;

    // const userRole =
    //   userInfo?.role || userInfo?.roleId?.name || userInfo?.userRole?.name;
    // if (userRole?.toLowerCase() !== "admin") {
    //   throw new Error("Access denied. Admin privileges required.");
    // }

    localStorage.setItem("token", response.data?.data?.token);
    localStorage.setItem("user", JSON.stringify(userInfo));

    setState((prev) => ({
      ...prev,
      token: response.data?.data?.token,
      user: userInfo,
      isLoading: false,
    }));
  };

  const logout = async () => {
    localStorage.clear();
    setState((prev) => ({
      ...prev,
      user: null,
      token: null,
      userProfile: null,
    }));
  };

  const configState = {
    isFluid: getItemFromStore("isFluid", settings.isFluid),
    isRTL: getItemFromStore("isRTL", settings.isRTL),
    isDark: getItemFromStore("isDark", settings.isDark),
    theme: getItemFromStore("theme", settings.theme),
    navbarPosition: getItemFromStore("navbarPosition", settings.navbarPosition),
    disabledNavbarPosition: [],
    isNavbarVerticalCollapsed: getItemFromStore(
      "isNavbarVerticalCollapsed",
      settings.isNavbarVerticalCollapsed,
    ),
    navbarStyle: getItemFromStore("navbarStyle", settings.navbarStyle),
    currency: settings.currency,
    showBurgerMenu: settings.showBurgerMenu,
    showSettingPanel: false,
    navbarCollapsed: false,
    openAuthModal: false,
  };

  const [config, configDispatch] = useReducer(configReducer, configState);

  const setConfig = (key, value) => {
    configDispatch({
      type: "SET_CONFIG",
      payload: {
        key,
        value,
        setInStore: [
          "isFluid",
          "isRTL",
          "isDark",
          "theme",
          "navbarPosition",
          "isNavbarVerticalCollapsed",
          "navbarStyle",
        ].includes(key),
      },
    });
  };
  const { isLoaded } = useToggleStyle(config.isRTL, config.isDark);

  useEffect(() => {
    const isDark =
      config.theme === "auto"
        ? window.matchMedia("(prefers-color-scheme: dark)").matches
        : config.theme === "dark";

    setConfig("isDark", isDark);
  }, [config.theme]);

  const changeTheme = (theme) => {
    const isDark =
      theme === "auto"
        ? window.matchMedia("(prefers-color-scheme: dark)").matches
        : theme === "dark";

    document.documentElement.setAttribute(
      "data-bs-theme",
      isDark ? "dark" : "light",
    );

    setConfig("theme", theme);
    setConfig("isDark", isDark);
  };

  if (!isLoaded) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: config.isDark ? getColor("dark") : getColor("light"),
        }}
      />
    );
  }

  // const values = useMemo(
  //   () => ({
  //     ...state,
  //     login,
  //     config,
  //     setConfig,
  //     configDispatch,
  //     changeTheme,
  //   }),
  //   [state]
  // );

  return (
    <AppContext.Provider
      value={{
        config,
        setConfig,
        configDispatch,
        changeTheme,
        login,
        logout,
        state, // contains user + agency
        agency: state.agency, // optional shortcut
        user: state.user, // optional shortcut
        userProfile: state.userProfile,
        isAdmin: isAdmin(),
        hasAdminAccess: hasAdminAccess(),
        hasRole: hasRole,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

Main.propTypes = { children: PropTypes.node };

export const useAppContext = () => useContext(AppContext);
export default Main;

// // Check for different roles
// const isSuperAdmin = hasRole('super-admin');
// const isEditor = hasRole('editor');
// const isViewer = hasRole('viewer');
